import { has } from 'lodash';
import { checkShowLicense } from "@/store/utils/helper";

export const cartoTileRe = /\/named\/tpl_([a-z0-9_]+)\/([a-z]+)\/\{z\}\/\{x\}\/\{y\}.png/gi;

export function getThumbnailUrl(visData, models, options) {
  const base_url = visData.permission.owner.base_url;
  const tpl = getTemplateNameByVisId(visData.id);
  let url = `${base_url}/api/v1/map/static/named/${tpl}/${options.width}/${options.height}.png`;
  if (visData.privacy == 'PUBLIC') {
    return url
  }
  if (visData.privacy == 'PRIVATE') {
    const authToken = visData.auth_tokens[0]
    return `${url}?auth_token=${authToken}`
  }
}

export function boundaryWKT2Bounds(boundaryWKT) {
  const re = /POLYGON\(\((.+)\)\)/gi;
  const matches = re.exec(boundaryWKT);
  if (matches && matches.length > 0) {
    const points = matches[1].split(",");
    const west_south = points[0].trim().split(" ").map((p) => parseFloat(p));
    const east_north = points[2].trim().split(" ").map((p) => parseFloat(p));
    return [
      [west_south[1], west_south[0]],
      [east_north[1], east_north[0]],
    ];
  }
  return null;
}

export function getTemplateNameByVisId(visId) {
  return `tpl_${visId.replace(/-/g, "_")}`;
}

function isCustomMap(visData) {
  return visData && checkShowLicense(visData);
}

//根据templateId和传入的layer索引,获取地图的瓦片地址
export function getMapTileUrl(visData) {
  const layer_count = visData.layer_count;

  let prefx = isCustomMap(visData) ? 'all' : 'mapnik'
  if (layer_count > 1) {
    let layersIndex = Array.from({ length: layer_count - 1 }, (v, k) => k + 1);
    prefx = layersIndex.join(",")
  }
  let url = `${visData.permission.owner.base_url}/api/v1/map/named/${getTemplateNameByVisId(visData.id)}/${prefx}/{z}/{x}/{y}.png`
  if (isCustomMap(visData)) {
    url = `${url}?version=2`
  }
  if (visData.privacy == 'PUBLIC') {
    return url
  }
  if (visData.privacy == 'PRIVATE') {
    const authToken = visData.auth_tokens[0]
    return `${url}?auth_token=${authToken}`
  }
}

export function getMapTileUrlWithLayers(mapTileUrl, layersIndex = []) {
  if (layersIndex.length > 0) {
    const layersStr = layersIndex.join(",")
    return mapTileUrl.replace(cartoTileRe, `/named/tpl_$1/${layersStr}/{z}/{x}/{y}.png`);
  }
  return mapTileUrl;
}

//将visData对象转换为earthLayer对象,便于添加图层时使用
export function convert2EarthLayer(visData, models, options) {
  if (has(visData, "layerServiceInfo")) {
    return {
      uid: visData.id,
      browseGraph: visData.browseGraph,
      name: visData.name,
      atomType: "LAYER_SERVICE",
      dataType: "RASTER",
      privilege: "PUBLIC",
      status: "LAYERED",
      keyword: "Global Layer Platform",
      bounds: visData.bounds,
      layerServiceInfo: {
        type: "TMS",
        method: "TMS",
        standard: "TMS",
        format: "PNG",
        sourceLayer: visData.name,
        url: visData.layerServiceInfo.url,
      },
    };
  }
  const browseGraph = getThumbnailUrl(visData, models, options);
  const tileUrl = getMapTileUrl(visData);
  const layer = {
    uid: visData.id,
    browseGraph: browseGraph,
    name: visData.name,
    atomType: "LAYER_SERVICE",
    dataType: "RASTER",
    privilege: "PUBLIC",
    status: "LAYERED",
    keyword: "Global Layer Platform",
    bounds: visData.bounds,
    layerServiceInfo: {
      type: "TMS",
      method: "TMS",
      standard: "TMS",
      format: "PNG",
      sourceLayer: visData.name,
      url: tileUrl,
    },
  };
  return layer;
}